import {AuthGuard} from '@auth0/auth0-angular';;
import { Routes } from '@angular/router';
import { LogEventsComponent } from './log-events.component';
import { LogEventListComponent } from './log-event-list/log-event-list.component';
import { ReadLogEventsGuard } from '../core/guards/read-log-events.guard';

export const LOG_EVENTS_ROUTES: Routes = [
  {
    path: 'log-events',
    data: { logEventsView: true },
    component: LogEventsComponent,
    canActivate: [AuthGuard, ReadLogEventsGuard],
    children: [
      { path: '', component: LogEventListComponent },
      { path: '**', redirectTo: '' }
    ]
  }
];
